import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    en: {
        langs: {
            en: 'En',
            gr: 'Gr',
        },
        generic: {
            address_set: 'Address is set',
            choose_valid_address: 'Please choose a valid street address',
            something_went_wrong: 'Something went wrong',
            network_error: 'Network error',
            wrong_credentials: 'Wrong credentials',
            update_business_successfully: 'Business updated successfully',
            business: 'Business',
            edit: 'Edit',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday',
            saturday: 'Saturday',
            sunday: 'Sunday',
            close: 'Close',
            create: 'Create',
            update: 'Update',
            delete: 'Delete',
        },
        rules: {
            required: 'Field is required',
        },
        menu: {
            newProduct: 'New product',
            editProduct: 'Edit product',
            deleteProduct: 'Delete product',
            deleteProductQuestion: 'Are you sure you want to delete product',
            title: 'Title',
            price: 'Price',
            description: 'Description',
            order: 'Order',
            visible: 'Visible',
            image: 'Image',
            selectImage: 'Select image',
            tags: 'Tags',
        },
        login: {
            header: 'Login',
            email: 'Email',
            password: 'Password',
            forgotPassword: 'Forgot password?',
            login: 'Login',
            gdpr: `By logging in, you agree to the <a href="https://pempo.app/terms-of-service"
                                                                     target="_blank">Terms of Service</a> and the <a
                                href="https://pempo.app/privacy-policy" target="_blank">Privacy Policy</a>.`,
            wrong_credentials: 'Wrong Credentials',
        },
        forgotPassword: {
            header: 'Forgot Password',
            email: 'Email',
            reset: 'Reset Password',
            success: 'We have sent you an email with instructions on how to reset your password.',
            error: 'There is no user registered with this email.',
            cancel: 'Back to login page',
        },
        main: {
            toolbar: {
                selectLanguage: 'Select language',
                englishLanguage: 'English',
                greekLanguage: 'Greek',
                businesses: 'Businesses',
                general: 'General',
                profile: 'Profile',
                logOut: 'Log out',
            },
            drawer: {
                business: 'Business',
                reviews: 'Reviews',
            },
        },
        business: {
            edit: 'Edit',
            basicInfo: 'BASIC INFO',
            name: 'Name',
            price: 'Price',
            website: 'Website',
            phone: 'Phone',
            score: 'Score',
            facebook: 'Facebook',
            instagram: 'Instagram',
            email: 'Email',
            location: 'LOCATION',
            country: 'Country',
            city: 'City',
            address: 'Address',
            workingHours: 'WORKING HOURS',
            mainCategories: 'SELECTED CATEGORIES',
            facilities: 'FACILITIES',
            services: 'SERVICES',
            amenities: 'AMENITIES',
            parkingOptions: 'PARKING OPTIONS',
            paymentOptions: 'PAYMENT OPTIONS',
        },
        editBusiness: {
            basicInfo: 'BASIC INFO',
            location: 'LOCATION',
            facilities: 'FACILITIES',
            services: 'SERVICES',
            amenities: 'AMENITIES',
            parkingOptions: 'PARKING OPTIONS',
            paymentOptions: 'PAYMENT OPTIONS',
            workingHours: 'WORKING HOURS',
            applyChanges: 'Apply changes',
            cancelChanges: 'Cancel',
            info: {
                name: 'Business name',
                logo: 'Business logo',
                price: 'Price range',
                phone: 'Phone',
                score: 'Score',
                facebook: 'Facebook',
                instagram: 'Instagram',
                website: 'Website',
                email: 'Email',
                mainCategories: 'Main categories',
                rules: {
                    required: 'The field is required',
                    name: 'Characters must be between 3 and 32',
                    tags: 'Provide 1 to 4 categories',
                    price: 'Price must be between 0 and 4',
                },
            },
            locationTab: {
                enterLocation: 'Enter a location',
                country: 'Country',
                city: 'City',
                zip: 'ZIP code',
                address: 'Address',
                longitude: 'Longitude',
                latitude: 'Latitude',
            },
            facilitiesTab: {
                facilities: 'Facilities',
                capacity: 'Capacity',
            },
            servicesTab: {
                services: 'Services',
            },
            amenitiesTab: {
                amenities: 'Amenities',
                musicStyles: 'Music styles',
                goodFor: 'Good for',
            },
            parkingOptionsTab: {
                parkingOptions: 'Parking options',
            },
            paymentOptionsTab: {
                paymentOptions: 'Payment options',
            },
            workingHoursTab: {
                fromTime: 'From time',
                toTime: 'To time',
            },
        },
    },
    gr: {
        generic: {
            address_set: 'Η διεύθυνση καταχωρήθηκε επιτυχώς',
            choose_valid_address: 'Παρακαλώ διαλέξτε μια έγκυρη διεύθυνση',
            something_went_wrong: 'Κάτι πήγε στραβά',
            network_error: 'Σφάλμα δικτύου',
            wrong_credentials: 'Λάθος διαπιστευτήρια',
            update_business_successfully: 'Η επιχείρηση ενημερώθηκε επιτυχώς',
            business: 'Επιχείρηση',
            edit: 'Επεξεργασία',
            monday: 'Δευτέρα',
            tuesday: 'Τρίτη',
            wednesday: 'Τετάρτη',
            thursday: 'Πέμπτη',
            friday: 'Παρασκευή',
            saturday: 'Σαββάτο',
            sunday: 'Κυριακή',
            close: 'Κλείσιμο',
            create: 'Δημιουργία',
            update: 'Ενημέρωση',
            delete: 'Διαγραφή',
        },
        rules: {
            required: 'Το πεδίο είναι υποχρεωτικό',
        },
        langs: {
            en: 'Αγ',
            gr: 'Ελ',
        },
        menu: {
            newProduct: 'Νέο προϊόν',
            editProduct: 'Επεξεργασία προϊόντος',
            deleteProduct: 'Διαγραφή προϊόντος',
            deleteProductQuestion: 'Είσαστε σίγουρος/η ότι θέλετε να διαγράψετε το προϊόν',
            title: 'Τίτλος',
            price: 'Τιμή',
            description: 'Περιγραφή',
            order: 'Σειρά',
            visible: 'Ορατό',
            image: 'Εικόνα',
            selectImage: 'Επιλογή εικόνας',
            tags: 'Ετικέτες',
        },
        login: {
            header: 'Σύνδεση',
            email: 'Email',
            password: 'Κωδικός Πρόσβασης',
            forgotPassword: 'Ξεχασατε τον κωδικό σας?',
            login: 'Είσοδος',
            gdpr: `Με τη σύνδεση, συμφωνείτε με τους <a href="https://pempo.app/terms-of-service"
                                                                     target="_blank">Όρους Χρήσης</a> και τη <a
                                href="https://pempo.app/privacy-policy" target="_blank">Πολιτική Απορρήτου</a>.`,
            wrong_credentials: 'Λάθος email ή κωδικός πρόσβασης',
        },
        forgotPassword: {
            header: 'Ξέχασα τον κωδικό πρόσβασης',
            email: 'Email',
            reset: 'Επαναφορά Κωδικού',
            success: 'Σας έχει σταλεί email με οδηγίες για την επαναφορά του κωδικού σας',
            error: 'Δεν υπάρχει εγγεγραμμένος χρήστης με το συγκεκριμένο email.',
            cancel: 'Πίσω στη σελίδα σύνδεσης',
        },
        main: {
            toolbar: {
                selectLanguage: 'Επιλογή γλώσσας',
                englishLanguage: 'Αγγλικά',
                greekLanguage: 'Ελληνικά',
                businesses: 'Επιχειρήσεις',
                general: 'Γενικά',
                profile: 'Προφίλ',
                logOut: 'Αποσύνδεση',
            },
            drawer: {
                business: 'Επιχείρηση',
                reviews: 'Αξιολογήσεις',
            },
        },
        business: {
            edit: 'Επεξεργασία',
            basicInfo: 'ΠΛΗΡΟΦΟΡΙΕΣ',
            name: 'Όνομα',
            price: 'Εύρος τιμών',
            website: 'Ιστοσελίδα',
            phone: 'Τηλέφωνο',
            score: 'Score',
            facebook: 'Facebook',
            instagram: 'Instagram',
            email: 'Email',
            location: 'ΤΟΠΟΘΕΣΙΑ',
            country: 'Χώρα',
            city: 'Πόλη',
            address: 'Διευθνση',
            workingHours: 'ΩΡΕΣ ΛΕΙΤΟΥΡΓΙΑΣ',
            mainCategories: 'ΕΠΙΛΕΓΜΕΝΕΣ ΚΑΤΗΓΟΡΙΕΣ',
            facilities: 'ΕΓΚΑΤΑΣΤΑΣΕΙΣ',
            services: 'ΥΠΗΡΕΣΙΕΣ',
            amenities: 'ΑΝΕΣΕΙΣ',
            parkingOptions: 'ΕΠΙΛΟΓΕΣ ΣΤΑΘΜΕΥΣΗΣ',
            paymentOptions: 'ΕΠΙΛΟΓΕΣ ΠΛΗΡΩΜΗΣ',
        },
        editBusiness: {
            basicInfo: 'ΠΛΗΡΟΦΟΡΙΕΣ',
            location: 'ΤΟΠΟΘΕΣΙΑ',
            facilities: 'ΕΓΚΑΤΑΣΤΑΣΕΙΣ',
            services: 'ΥΠΗΡΕΣΙΕΣ',
            amenities: 'ΑΝΕΣΕΙΣ',
            parkingOptions: 'ΕΠΙΛΟΓΕΣ ΣΤΑΘΜΕΥΣΗΣ',
            paymentOptions: 'ΕΠΙΛΟΓΕΣ ΠΛΗΡΩΜΗΣ',
            workingHours: 'ΩΡΕΣ ΛΕΙΤΟΥΡΓΙΑΣ',
            applyChanges: 'Αποθήκευση αλλαγών',
            cancelChanges: 'Πίσω',
            info: {
                name: 'Όνομα επιχείρησης',
                logo: 'Λογότυπο επιχείρησης',
                price: 'Εύρος τιμών',
                phone: 'Τηλέφωνο',
                website: 'Ιστοσελίδα',
                score: 'Score',
                facebook: 'Facebook',
                instagram: 'Instagram',
                email: 'Email',
                mainCategories: 'Κύριες κατηγορίες',
                rules: {
                    required: 'Το πεδίο είναι υποχρεωτικό',
                    name: 'Οι χαρακτήρες πρέπει να είναι μεταξύ 3 και 32',
                    tags: 'Επιλέξτε από 1 μέχρι 4 κατηγορίες',
                    price: 'Το εύρος τιμών είναι μεταξύ 0 και 4',
                },
            },
            locationTab: {
                enterLocation: 'Εισάγετε μια διεύθυνση',
                country: 'Χώρα',
                city: 'Πόλη',
                zip: 'Ταχυδρομικός κώδικας',
                address: 'Διεύθυνση',
                longitude: 'Γεωγραφικό μήκος',
                latitude: 'Γεωγραφικό πλάτος',
            },
            facilitiesTab: {
                facilities: 'Εγκαταστάσεις',
                capacity: 'Χωρητικότητα',
            },
            servicesTab: {
                services: 'Υπηρεσίες',
            },
            amenitiesTab: {
                amenities: 'Ανέσεις',
                musicStyles: 'Μουσικά ήδη',
                goodFor: 'Συστήνεται για',
            },
            parkingOptionsTab: {
                parkingOptions: 'Επιλογές στάθμευσης',
            },
            paymentOptionsTab: {
                paymentOptions: 'Επιλογές πληρωμής',
            },
            workingHoursTab: {
                fromTime: 'Από',
                toTime: 'Μέχρι',
            },
        },
    },
};

let locale = 'en';
const language = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage;
if (language.toLowerCase() === 'el' || language.toLowerCase() === 'el-gr' || language.toLowerCase() === 'gr') {
    locale = 'gr';
} else {
    locale = 'en';
}
localStorage.setItem('lang', locale);

export const i18n = new VueI18n({
    locale, // set locale
    fallbackLocale: 'en',
    messages, // set locale messages
});
